import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/mocuts/banner_back.webp";

function Banner(props) {
  return (
    <div
      className="banner_soundly banner_mocuts"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={4}
            xxl={4}
            className="m-auto text-center"
          >
            <StaticImage
              src="../../../images/case-studies/mocuts/logo.webp"
              alt="Soundly_TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={516}
              height={137}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
